module.exports = __webpack_public_path__ + "static/media/travisscott-astroworld.878bb0d2.jpg";